import camelize from 'camelize'
import { useGeckoAuth } from 'features/auth'
import { RolodexContext } from 'features/rolodex/RolodexProvider'
import { useCallback, useContext } from 'react'
import useSWR from 'swr'
import { RolodexUserMetadata } from 'types'

export const useGetUserMetadata = (userId?: string) => {
  const { isAuthenticated, authorizedAxios: axios } = useGeckoAuth()
  const { apiURL } = useContext(RolodexContext)

  const fetcher = useCallback(
    async (endpoint: string) => {
      return new Promise<RolodexUserMetadata>((resolve, reject) => {
        if (!isAuthenticated) {
          reject(new Error('User is not authenticated'))
          return null
        }
        return axios
          .get(`${apiURL}${endpoint}`, {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          })
          .then((res) => {
            resolve(camelize(res.data))
          })
          .catch((err) => reject(err))
      })
    },
    [axios, apiURL, isAuthenticated]
  )

  const { data, error, isLoading, isValidating } = useSWR<
    RolodexUserMetadata,
    string
  >(
    isAuthenticated ? `/api/v2/permissions/user-metadata/${userId}` : null,
    fetcher
  )

  return { data, error, isLoading, isValidating }
}
